/*
 * BroadcastChannel wrapper for same-browser tab gossip.
 * See IMPLEMENTATION_PLAN.md §4 "Saving — robustness model".
 */

export type BroadcastEvent =
  | { type: 'scene-updated'; sceneId: string; version: number }
  | { type: 'scene-deleted'; sceneId: string }
  | { type: 'image-added'; sceneId: string; imageId: string }
  | { type: 'video-added'; sceneId: string; videoId: string };

let channel: BroadcastChannel | null = null;
let currentEpisodeUuid: string | null = null;

export function openChannel(episodeUuid: string): BroadcastChannel {
  if (channel && currentEpisodeUuid === episodeUuid) return channel;
  closeChannel();
  channel = new BroadcastChannel(`studio-v2-${episodeUuid}`);
  currentEpisodeUuid = episodeUuid;
  return channel;
}

export function closeChannel(): void {
  if (channel) {
    channel.close();
    channel = null;
    currentEpisodeUuid = null;
  }
}

export function broadcast(event: BroadcastEvent): void {
  channel?.postMessage(event);
}

export function onBroadcast(handler: (event: BroadcastEvent) => void): () => void {
  if (!channel) return () => {};
  const listener = (e: MessageEvent<BroadcastEvent>) => handler(e.data);
  channel.addEventListener('message', listener);
  return () => channel?.removeEventListener('message', listener);
}
